import { Children, forwardRef, ReactElement, ReactNode } from 'react';

import MuiTabs, { TabsProps as MuiTabsProps } from '@mui/material/Tabs';
import Tab from '../Tab';
import { styled } from '@mui/material/styles';
export * from '@mui/material/Tabs';

export type HeadlinesType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface StyledTabsOwnerState {
  textVariant?: HeadlinesType;
}
export interface TabsProps extends Omit<MuiTabsProps, 'indicatorColor'> {
  indicatorColor?: 'primary' | 'secondary' | 'grey' | 'internal';
  withoutIndicator?: boolean;
  isSubMenu?: boolean;
  textVariant?: HeadlinesType;
}

const StyledMuiTabs = styled(MuiTabs, {
  name: 'O2Tabs',
})<{ ownerState: StyledTabsOwnerState }>(({ ownerState: { textVariant } }) => ({
  ...(textVariant === 'h1' && {
    minHeight: '49px',
  }),
  ...(textVariant === 'h2' && {
    minHeight: '45px',
  }),
  ...(textVariant === 'h3' && {
    minHeight: '41px',
  }),
  ...(textVariant === 'h4' && {
    minHeight: '38px',
  }),
  ...(textVariant === 'h5' && {
    minHeight: '34px',
  }),
  ...(textVariant === 'h6' && {
    minHeight: '31px',
  }),
}));

const Tabs = forwardRef<HTMLButtonElement, TabsProps>(({ children, textVariant, ...props }, ref) => {
  return (
    <StyledMuiTabs
      ownerState={{
        textVariant,
      }}
      {...(props as MuiTabsProps)}
      ref={ref}
    >
      {Children.map(children, (child: ReactNode) => {
        if (!child) return null;
        if (typeof child !== 'object') return child;

        return <Tab textVariant={textVariant} key={(child as ReactElement).key} {...(child as ReactElement).props} />;
      })}
    </StyledMuiTabs>
  );
});

Tabs.displayName = 'Tabs';

export default Tabs;
